<div class="modal">
  <div class="main">
    <div class="content">
      <h2>{{ header }}</h2>
      <br />
      <h3 class="sanitized-content" [innerHtml]="message"></h3>

      <div class="buttons">
        <p class="jeopardy-button primary">
          <a href="#" (click)="close($event)">{{ cancelButtonLabel }}</a>
        </p>
      </div>
    </div>
  </div>
</div>
